import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import isEqual from 'lodash/isEqual';
import { AppSettings } from '../../constants';
import * as PubSubActionType from 'services/constants';
import { ToastContainer, toast } from 'react-toastify';
import PubSub from '../../services/pubsub-service';
import { Indicator } from '../indicators/indicator';
import * as SettingActionType from 'Setting/constants';

class TemplateRoot extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    style: PropTypes.any,
    CustomStyle: PropTypes.object,
    dispatch: PropTypes.func
  };

  constructor(prop) {
    super(prop);
    this.state = {};
  }

  componentDidMount() {
    if (AppSettings.clientTypeValue === 'Builder') {
      document.body.style.setProperty(
        '--primary-color',
        window.profile.customStyleJson.primaryPalette
      );

      document.body.style.setProperty(
        '--secondary-color',
        window.profile.customStyleJson.secondaryPalette
      );

      this.props.dispatch({
        type: SettingActionType.UPDATE_CUSTOM_COLOR_PALETTES_SUCCESS,
        data: window.profile.customStyleJson
      });

      this.props.dispatch({
        type: SettingActionType.SET_CURRENT_CUSTOM_COLOR,
        data: window.profile.customStyleJson
      });
      
      this.props.dispatch({
        type: SettingActionType.UPDATE_HO_CUSTOM_COLOR_PALETTES_SUCCESS,
        data: window.profile.hobrand
      });

      this.props.dispatch({
        type: SettingActionType.SET_HO_CURRENT_CUSTOM_COLOR,
        data: window.profile.hobrand
      });
    }
    // if (AppSettings.clientTypeValue === 'Homeowner') {
    //   document.body.style.setProperty(
    //     '--primary-color',
    //     window.profile.hobrand.primaryPalette
    //   );

    //   document.body.style.setProperty(
    //     '--secondary-color',
    //     window.profile.hobrand.secondaryPalette
    //   );

    //   this.props.dispatch({
    //     type: SettingActionType.UPDATE_HO_CUSTOM_COLOR_PALETTES_SUCCESS,
    //     data: window.profile.hobrand
    //   });

    //   this.props.dispatch({
    //     type: SettingActionType.SET_HO_CURRENT_CUSTOM_COLOR,
    //     data: window.profile.hobrand
    //   });
    // }

    PubSub.subscribe(PubSubActionType.ROOT_TOAST_SUCCESS, (msg, data) => {
      toast.success(data.msg, {});
    });

    PubSub.subscribe(PubSubActionType.ROOT_TOAST_ERROR, (msg, data) => {
      toast.error(data.msg, {});
    });

    PubSub.subscribe(PubSubActionType.LOADING_INDICATOR, (msg, data) => {
      if (!data.isHideIndicator) {
        this.setState({ showIndicator: true });
      } else {
        //   $("#IndicatorID").hide();
        this.setState({ showIndicator: false });
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    if (AppSettings.clientTypeValue === 'Builder') {
      if (!isEqual(nextProps.CustomStyle, this.props.CustomStyle)) {
        document.body.style.setProperty(
          '--primary-color',
          nextProps.CustomStyle.primaryPalette
        );
        document.body.style.setProperty(
          '--secondary-color',
          nextProps.CustomStyle.secondaryPalette
        );
      }
    }
  }

  componentWillUnmount() {
    PubSub.unsubscribe(PubSubActionType.LOADING_INDICATOR);
    PubSub.unsubscribe(PubSubActionType.ROOT_TOAST_SUCCESS);
    PubSub.unsubscribe(PubSubActionType.ROOT_TOAST_ERROR);
  }

  renderLogo() {
    if (AppSettings.clientTypeValue === 'Homeowner') {
      return <div style={{ fontSize: 20 }}>Homeowner portal</div>;
    }
    if (AppSettings.LOGO_30 !== '' && AppSettings.LOGO_30 !== null) {
      return <img className='logo' src={AppSettings.LOGO_30} />;
    } else if (AppSettings.COMPANY_NAME) {
      return <div className='text-logo'>{AppSettings.COMPANY_NAME}</div>;
    } else {
      return <img className='logo' src='images/logo_30.png' />;
    }
  }

  render() {
    const className = this.props.className
      ? `wrapper-content ${this.props.className}`
      : 'wrapper-content';

    return (
      <div className='wrapper wrapper-full-page wrapper-outsite-page wrapper-template-page'>
        <div className='template-header text-center'>
          <div className='container'>
            <div className='logo center-block margin-top-10'>
              {this.renderLogo()}
            </div>
          </div>
        </div>
        <div className={className} style={this.props.style}>
          {this.props.children}
        </div>
        <Indicator id='IndicatorID' show={this.state.showIndicator} />
        <ToastContainer position='top-right' autoClose={2000} />
      </div>
    );
  }
}

TemplateRoot.propTypes = {
  rootTemplate: PropTypes.object,
  children: PropTypes.object
};

const mapStateToProps = state => {
  const props =
    AppSettings.clientTypeValue === 'Builder'
      ? {
        CustomStyle: state.SettingStore.CustomStyle
      }
      : {};
  return props;
};

export default connect(mapStateToProps)(TemplateRoot);



// WEBPACK FOOTER //
// ./src/components/Layout/SiteOneTemplate.js